import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import React, { useState } from "react";
import "../DeleteConfirmationModal/DeleteConfirmationModal.css";

interface CreateTrackingModalProps {
  onClose: () => void;
  onSubmit: (shipmentId: string) => Promise<void>;
  isSubmitting: boolean;
}

const CreateTrackingModal: React.FC<CreateTrackingModalProps> = ({
  onClose,
  onSubmit,
  isSubmitting,
}) => {
  const [shipmentId, setShipmentId] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = shipmentId.trim();
    if (!trimmed) return;
    await onSubmit(trimmed);
  };

  return (
    <Modal title={<>Create Tracking</>} onClose={onClose} size="medium">
<div className="modal-content legacy-modal-content">

        <p>Enter the shipment ID to create a tracking entry.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={shipmentId}
            onChange={(e) => setShipmentId(e.target.value)}
            placeholder="Shipment ID"
            disabled={isSubmitting}
            style={{
              width: "100%",
              padding: "10px 12px",
              margin: "12px 0 20px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          />
          <div className="modal-actions">
            <Button
              type="button"
              className="btn-cancel"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button variant="danger"
              type="submit"
              className="btn-delete"
              disabled={isSubmitting || !shipmentId.trim()}
              style={{ backgroundColor: "#174078" }}
            >
              {isSubmitting ? "Creating..." : "Create"}
            </Button>
          </div>
        </form>
      </div>
</Modal>
  );
};

export default CreateTrackingModal;
